import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import ErrorModal from '../application/ErrorModal'
import { setAttribute } from '../../actions/registration'


class HomeStepThree extends Component {
  constructor(props) {
    super(props)

    this.onFormSubmit = this.onFormSubmit.bind(this)

    this.state = {
      error: '',
    }
  }

  componentDidMount() {
    if (!this.props.startOk) {
      this.props.history.push('/')
    }
  }

  onRegistroChange(id, event) {
    const item = this.props.registration.selectedActions.find((item) => {
      return item.id === id
    })

    const newItem = {
      ...item,
      num_registro: event.currentTarget.value,
    }

    const index = this.props.registration.selectedActions.findIndex((item) => {
      return (item.id === id)
    })

    const selectedActions = this.props.registration.selectedActions

    this.props.setAttribute('selectedActions', [
      ...selectedActions.slice(0, index),
      newItem,
      ...selectedActions.slice(index + 1),
    ])
  }


  onFormSubmit(event) {
    event.preventDefault()

    const required = this.props.registration.selectedActions.find((item) => {
      return item.registro !== undefined && item.registro !== null && (item.num_registro === null || item.num_registro === undefined)
    })
    if (required) {
      this.setState({
        error: 'Por favor, informe o numero de registro',
      })
      this.modal.show()
      return
    }

    this.props.setAttribute('start-ok', true)

    this.props.history.push('/step4')
  }

  renderActions(item){
    if(item.registro !== null)
      return (
        <div  key={item.id} className="form-validacao-itens registroprofissional">
          <label>
            <p>Atividade selecionada: <b>{item.nome}</b><br />
              <span>{item.registro}</span>
            </p>
            <input
              ref={(ref) => { this.registroinput = ref }}
              value={item.num_registro}
              onChange={this.onRegistroChange.bind(this, item.id)}
              placeholder={item.registro}
              type="text"
            />
          </label>
        </div>
      )
    return null
  }

  getActions() {
    return this.props.registration.selectedActions.map(this.renderActions.bind(this))
  }

  onClickBack(){
    this.props.history.push('/step2')
  }

  render() {
    return (
      <div>
        <div className="formulario-compromisso">
          <div className="modal-header">
            <div className="container">
              <div className="img-voltar">
                <a onClick={this.onClickBack.bind(this)}>
                  <img src="images/voltar.png" alt="Voltar" />
                </a>
              </div>
              <div className="sobre">Confirme sua especialidade</div>
            </div>
          </div>
          <div className="modal-body">
            <div className="container">
              <div className="chamada-modal">
                <p className="detalhe">O serviço que você escolheu precisa da confirmação de sua especialidade</p>
                <p>Para continuar é preciso que nos envie o número de seu registro profissional.</p><br/>
              </div>
              {this.getActions()}
              <div className="bt-fechar-tudo">
                <a onClick={this.onFormSubmit}>
                  <button className="bt fecharpedido">Continuar</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      <ErrorModal
        ref={(ref) => { this.modal = ref }}
        message={this.state.error}
      />
      </div>
    )
  }
}

HomeStepThree.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  registration: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    telefone: PropTypes.string,
    city: PropTypes.string,
  }).isRequired,
  setAttribute: PropTypes.func.isRequired,
  startOk: PropTypes.bool.isRequired,
}

HomeStepThree.defaultProps = {
  history: {
    push: () => { },
  },
}

const mapStateToProps = state => ({
  registration: state.registration,
  startOk: !!state.registration['start-ok'],
})

const mapDispatchToProps = {
  setAttribute,
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeStepThree)



// WEBPACK FOOTER //
// ./src/components/home/StepThree.js